<div id="price-factors">
	@if (shouldShowTotalModifiers()) {
		<div class="total-modifiers">
			<div>Total In- & decreases</div>
			<div [nbTooltipClass]="'total-modifiers-tooltip'" nbTooltip="{{totalModifierText}}" #tooltipModifiersInfo="nbTooltip"
				 [nbTooltipPlacement]="nbStart" [nbTooltipTrigger]="hover">APPLIED: {{ getAppliedDiscount() }}% | SELECTED: {{ getCalculatedDiscount() }}%
			</div>
		</div>
	}
	@for (priceFactor of product.priceFactors; track priceFactor.type; let index = $index) {
		<div class="form-row radio-row" nbTooltip="{{percentageFactors(priceFactor)}}" [nbTooltipPlacement]="nbStart" [nbTooltipTrigger]="noop" #tooltipPriceFactors="nbTooltip"
			 (mouseover)="showTooltipIfAllowed(index)" (mouseleave)="hideTooltip(index)"
			 [class.margin-bottom10]="priceFactor.attachedQuestions != null && priceFactor.attachedQuestions.length == 0">
			<div class="radio-column">
				<nb-radio id="price-factor-{{priceFactor.type.toLowerCase()}}-{{standardName().toLowerCase()}}" [name]="'price-factor-' + priceFactor.type.toLowerCase() + '-' + RANDOM_NUMBER"
						  [checked]="true" status="primary">
					{{ priceFactor.positiveAnswer | booleanDisplay }}
				</nb-radio>
			</div>
			<div class="radio-description-column">
				{{ priceFactor.question }}
				<change-label [visible]="isPriceFactorChanged(priceFactor)" [changeSet]="changeSet"></change-label>
			</div>
		</div>
		@if (priceFactor.attachedQuestions != null) {
			@for (attachedQuestion of priceFactor.attachedQuestions; track attachedQuestion.type) {
				<div>
					<div class="price-factor-question-wrapper form-row radio-row attached-question-row">
						<div class="radio-column"></div>
						<div class="radio-description-column">
							<span class="attached-question-answer">{{ attachedQuestion.answer }}</span>
						</div>
					</div>
					@if (translationsHelper.translationExists(standardName(), getTranslationSubjectForPriceFactorQuestion(priceFactor, attachedQuestion), useOriginalTranslations)) {
						<div
							class="translation-wrapper">
							<translation-field [standard]="standardName()"
											   [previewMode]="!translateClientsData"
											   [translatedText]="translationsHelper.getTranslation(standardName(), getTranslationSubjectForPriceFactorQuestion(priceFactor, attachedQuestion), useOriginalTranslations)"
											   [translationSubject]="getTranslationSubjectForPriceFactorQuestion(priceFactor, attachedQuestion)"></translation-field>
						</div>
					}
				</div>
			}
		}
	}
</div>
